import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = [
    'div',
    'div2',
    'multiple',
    'passwordField',
    'otherReason',
    'otherReasonInput'
  ]
  connect() {}

  toggleOtherReason(event) {
    if (!this.hasOtherReasonTarget) return

    const otherValue = event.currentTarget.dataset.toggleOtherValue
    const selectedValue = event.currentTarget.value
    const showOtherReason = selectedValue === otherValue

    this.otherReasonTarget.classList.toggle('hidden', !showOtherReason)
    if (!showOtherReason && this.hasOtherReasonInputTarget) {
      this.otherReasonInputTarget.value = ''
    }
  }

  toggle() {
    this.divTarget.classList.toggle('hidden')
  }

  toggleScroll(event) {
    const toggleBox = event.currentTarget
    const content = toggleBox.querySelector('[data-toggle-target="div"]')
    const parent = toggleBox.closest('.overflow-y-scroll')

    content.classList.toggle('hidden')

    if (!parent) return // Avoid undefined behavior if parent isn't found

    requestAnimationFrame(() => {
      const boxBottom = toggleBox.offsetTop + toggleBox.offsetHeight
      const visibleBottom = parent.scrollTop + parent.clientHeight

      if (boxBottom > visibleBottom) {
        parent.scrollTo({
          top: boxBottom - parent.clientHeight + 20,
          behavior: 'smooth'
        })
      }
    })
  }

  toggleReload() {
    window.location.reload()
  }

  toggle2() {
    this.div2Target.classList.toggle('hidden')
  }

  toggleMultiple() {
    console.log('toggleMultiple')
    this.multipleTargets.forEach((element) => {
      element.classList.toggle('hidden')
    })
  }

  showMultiple() {
    this.multipleTargets.forEach((element) => {
      element.classList.remove('hidden')
    })
  }

  hideMultiple() {
    this.multipleTargets.forEach((element) => {
      element.classList.add('hidden')
    })
  }

  scrollToggle() {
    document.querySelector('body').classList.toggle('overflow-hidden')
  }

  delayedToggleMultiple() {
    this.toggleMultiple()
    setTimeout(() => {
      this.toggleMultiple()
    }, 1000)
  }

  delayedToggleMultiple2() {
    this.toggleMultiple()
    setTimeout(() => {
      this.toggleMultiple()
    }, 500)
  }

  delayedToggleMultiple3() {
    this.toggleMultiple()
    setTimeout(() => {
      this.toggleMultiple()
    }, 3000)
  }

  togglePassword() {
    console.log('tpassword')
    let inputField = this.passwordFieldTarget
    if (inputField.type === 'password') {
      inputField.type = 'text'
    } else {
      inputField.type = 'password'
    }
  }

  toggleInstruments(e) {
    console.log('toggleInstruments')
    console.log(e.currentTarget.value)
    let instruments = ['drums', 'guitar', 'keyboard', 'vocals']
    instruments.forEach((instrument) => {
      if (instrument === e.currentTarget.value) {
        const background = document.getElementById(`${instrument}-selected-bg`)
        background.classList.remove('hidden')
        const iconSelected = document.getElementById(
          `${instrument}-instrument-bold-selected`
        )
        iconSelected.classList.remove('hidden')
        const iconDefault = document.getElementById(
          `${instrument}-instrument-new`
        )
        iconDefault.classList.add('hidden')
      } else {
        const background = document.getElementById(`${instrument}-selected-bg`)
        background.classList.add('hidden')
        const iconSelected = document.getElementById(
          `${instrument}-instrument-bold-selected`
        )
        iconSelected.classList.add('hidden')
        const iconDefault = document.getElementById(
          `${instrument}-instrument-new`
        )
        iconDefault.classList.remove('hidden')
      }
    })
  }
}
